import React, { useEffect, useState } from 'react';
import { Alert, Card, Col, Row, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { useUnitContext } from '../../context/UnitContext';
export default function UnitCrmDashboard() {
  const unit = useUnitContext()?.selected;
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true; setData(null); setError(false);
    axios.get('/api/crm/unit-summary').then(r => { if (active) setData(r.data); }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [unit?.id]);
  if (error) return <Alert variant="danger">Não foi possível carregar os indicadores desta unidade.</Alert>;
  if (!data) return <Spinner animation="border" />;
  const labels = { novo: 'Novos', contatado: 'Contatados', convertido: 'Convertidos', perdido: 'Perdidos' };
  return <div className="p-3"><h3>CRM — {unit?.nome}</h3><p className="text-muted">Indicadores da unidade selecionada, respeitando seu acesso aos leads.</p>
    <Row className="g-3">{[['Leads', data.total], ['Sem responsável', data.unassigned], ...Object.entries(data.statuses).map(([key,value]) => [labels[key] || key, value])].map(([label,value]) => <Col md={4} key={label}><Card className="h-100 border-0 shadow-sm"><Card.Body><div className="text-muted">{label}</div><strong className="fs-2">{value}</strong></Card.Body></Card></Col>)}</Row>
  </div>;
}
